import React, { useState } from "react";
import { serverUrl } from "../utils/Constants";
import axios from "axios";
import "../styles/contactUs.css";

export default function ContactUs() {
  // const [formState, setFormState] = useState({});
  const [popupMessage, setPopupMessage] = useState(null);

  // function changeHandler(event) {
  //   setFormState({ ...formState, [event.target.name]: event.target.value });
  // }

  function submitHandler(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append("formType", "contact");
    try {
      axios.post(`${serverUrl}/send-email.php`, formData).then((res) => {
        e.target.reset();
        setPopupMessage("Message successfully sent!");
        // alert(res.data);
      });
    } catch (error) {
      setPopupMessage("An error occurred. Please try again.");
    }
  }

  return (
    <>
      <section id="aboutUs">
        <div className="mcare-contact-us">
          <div className="container">
            <h2 align="left" style={{ fontSize: "30px" }}>
              METAK India <span style={{ color: "#005598" }}>Contact Us</span>
            </h2>
            <div className="row g-5 pt-5">
              <div className="col-md-6 col-sm-12 text-start">
                <h5 className="add-border-bottom">Contact Form</h5>
                <form onSubmit={submitHandler}>
                  <div className="mb-3">
                    <input type="text" className="form-control" name="name" placeholder="Your Name"></input>
                  </div>
                  <div className="mb-3">
                    <input type="email" className="form-control" name="email" placeholder="Your Email Id"></input>
                  </div>
                  <div className="mb-3">
                    <input type="text" className="form-control" name="telephone" placeholder="Contact Number"></input>
                  </div>
                  <div className="mb-3">
                    <input type="text" className="form-control" name="subject" placeholder="Subject"></input>
                  </div>
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      name="message"
                      rows="6"
                      placeholder="Your Message Here.."
                    ></textarea>
                  </div>
                  <button className="btn btn-primary btn-block" type="submit" style={{ width: "100%" }}>
                    Send
                  </button>
                </form>
                {popupMessage && (
                  <div className="popup">
                    <p>{popupMessage}</p>
                    <button onClick={() => setPopupMessage(null)}>Close</button>
                  </div>
                )}
              </div>
              <div className="col-md-5 col-sm-12 ms-lg-5 text-start">
                <h5 className="add-border-bottom">
                  Important <span style={{ color: "#005598" }}>Contacts</span>
                </h5>
                <p>
                  <strong>METAK HEALTHCARE INDIA PVT. LTD.</strong>
                </p>
                <h6 style={{ padding: "20px 0px" }}>CONTACT PERSONS:</h6>
                <p>
                  <strong>ABHISHEK SINHA (DIRECTOR)</strong>
                  <br></br>TELE: 01146560397 <br></br>MOB: +919312929895, +918447214545
                </p>
                <br></br>
                <p>
                  <strong>COL. KARTIKEY SINHA (RETD.)</strong>
                  <br></br>(FOUNDER & MANAGING DIRECTOR) <br></br>TELE: 01146560397 <br></br>MOB: +919312929895
                </p>
                <br></br>
                <p>
                  <strong>OFFICE ADDRESS:</strong> <br></br>C-6/9, C-BLOCK, VASANT VIHAR, <br></br>NEW DELHI - 110057
                  <br></br>TELE: +919312929895, 011-46560397
                </p>
              </div>
            </div>
            <h2 className="border-style">Reach Us</h2>
            <div style={{ margin: "-6px -162px" }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d876.0094188080221!2d77.15888161342244!3d28.56863136314852!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1d751ad551ff%3A0x4902bb113dc5c12e!2sMETAK%20Healthcare%20India%20PVT.%20LTD.!5e0!3m2!1sen!2sin!4v1705843366290!5m2!1sen!2sin"
                height="450"
                style={{ border: "0", width: "100%" }}
                allowFullScreen={false}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
